import React, { useEffect, useState } from "react";
import {
  CircularEditIcon,
  CubeWithBlueBgIcon,
  RightArrow,
  SheetWithPinkBgIcon,
  WalletWithPurpleBgIcon,
} from "../../../assets/images";
import { formatDate, formateDateTime } from "../../../utils/commonFunctions";
import "./styles.scss";
import PrimaryDetails from "./PrimaryDetails";
import ItemDetails from "./ItemDetails";
import PaymentDetails from "./PaymentDetails";
type AppProps = {
  history: any;
  data: any;
  index: number;
};

const SingleUpdatedByDetails = ({ history, data, index }: AppProps) => {
  function capitalizeWords(str: string) {
    if (str?.includes("_")) {
      return str
        ?.split("_")
        ?.map((word: string) => {
          return word?.charAt(0)?.toUpperCase() + word?.slice(1);
        })
        .join(" ");
    } else {
      return str;
    }
  }

  const getDataObject = (data: any, type: string) => {
    let finalObj = data?.find((item: any) => item?.title === type);
    const getPreviousData = (title: string) => {
      switch (title) {
        case "Bill From":
          return finalObj?.previous_value?.trade_name;
        case "Branch":
        case "branch_details":
          return finalObj?.previous_value?.trade_name;
        case "Supplier Name":
        case "Customer Name":
        case "Ship To Name":
          return finalObj?.previous_value?.legal_name;
        case "Place Of Supply":
        case "Place of Supply":
        case "Document Type":
        case "Currency":
        case "SKU Code":
        case "Batch Number":

        case "Department":
          return finalObj?.previous_value?.label;
        case "Nature of Expense":
        case "Nature of Income":
        case "Mode of Payment":
        case "Mode of Receipts":
        case "account_details":
          return finalObj?.previous_value?.ledger_name;
        case "File Upload":
        case "upload":
          return finalObj?.previous_value?.length > 0
            ? finalObj?.previous_value?.map((item: any) => item?.file_name)
            : null;
        case "Mapping Tax Invoice":
          return finalObj?.previous_value;
        case "date_of_invoice" : 
          return formatDate(finalObj?.previous_value) ==="Invalid date" ? "" : formatDate(finalObj?.previous_value);
        default:
          return finalObj?.previous_value;
      }
    };

    const getCurrentData = (title: string) => {
      switch (title) {
        case "Bill From":
          return finalObj?.current_value?.trade_name;
        case "Branch":
        case "branch_details":
          return finalObj?.current_value?.trade_name;
        case "Supplier Name":
        case "Customer Name":
        case "Ship To Name":
          return finalObj?.current_value?.legal_name;
        case "Place Of Supply":
        case "Place of Supply":
        case "Document Type":
        case "Currency":
        case "SKU Code":
          
        case "Batch Number":
        case "Department":
          return finalObj?.current_value?.label;
        case "Nature of Expense":
        case "Nature of Income":
        case "Mode of Payment":
        case "Mode of Receipts":
        case "account_details":
          return finalObj?.current_value?.ledger_name;
        case "File Upload":
        case "upload":
          return finalObj?.current_value?.length > 0
            ? finalObj?.current_value?.map((item: any) => item?.file_name)
            : null;
        case "Mapping Tax Invoice":
          return finalObj?.current_value;
        case "date_of_invoice" : 
          return formatDate(finalObj?.current_value) ==="Invalid date" ? "" : formatDate(finalObj?.current_value);
        default:
          return finalObj?.current_value;
      }
    };

    return (
      <div className="d-flex" style={{ gap: "20px", alignItems: "center" }}>
        <div className="previous">
          <div className="sub_heading ">{capitalizeWords(type)}</div>
          {type == "File Upload" ? (
            <div
              className="mt-1 primary_text"
              style={{ textDecoration: "line-through" }}
            >
              {getPreviousData(type)?.length > 0
                ? getPreviousData(type)?.map((item: any) => <div>{item}</div>)
                : "NA"}
            </div>
          ) : type == "Mapping Tax Invoice" ? (
            <div>
              {!!getPreviousData(type) ? (
                <div>
                  {getPreviousData(type)?.voucher_invoice_number ? (
                    <div className="mb-2 mt-2">
                      <div className="mb-1 sub_heading">
                        Voucher Invoice Number
                      </div>
                      <div
                        className="primary_text"
                        style={{ textDecoration: "line-through" }}
                      >
                        {getPreviousData(type)?.voucher_invoice_number}
                      </div>
                    </div>
                  ) : null}

                  {getPreviousData(type)?.voucher_invoice_date ? (
                    <div className="mt-1">
                      <div className="mb-1  sub_heading">
                        Voucher Invoice Date
                      </div>
                      <div
                        className="primary_text"
                        style={{ textDecoration: "line-through" }}
                      >
                        {getPreviousData(type)?.voucher_invoice_date}
                      </div>
                    </div>
                  ) : null}

                  {getPreviousData(type)?.net_amount ? (
                    <div className="mt-1">
                      <div className="mb-1  sub_heading">Net Amount</div>
                      <div
                        className="primary_text"
                        style={{ textDecoration: "line-through" }}
                      >
                        {getPreviousData(type)?.net_amount}
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                <div
                  className="mt-1 primary_text"
                  style={{ textDecoration: "line-through" }}
                >
                  NA
                </div>
              )}
            </div>
          ) : (
            <div
              className="mt-1 primary_text"
              style={{ textDecoration: "line-through" }}
            >
              {getPreviousData(type) ? getPreviousData(type) : "NA"}
            </div>
          )}
        </div>

        <div className="middle">
          <img src={RightArrow} alt="" />
        </div>

        <div className="current">
          <div className="sub_heading">{capitalizeWords(type)}</div>
          {type == "File Upload" ? (
            <div className="mt-1 primary_text">
              {getCurrentData(type)?.length > 0
                ? getCurrentData(type)?.map((item: any) => <div>{item}</div>)
                : "NA"}
            </div>
          ) : type == "Mapping Tax Invoice" ? (
            <div>
              <div>
                {getCurrentData(type)?.voucher_invoice_number ? (
                  <div className="mb-1">
                    <div className="mb-1 mt-2  sub_heading">
                      Voucher Invoice Number
                    </div>
                    <div className="primary_text">
                      {getCurrentData(type)?.voucher_invoice_number}
                    </div>
                  </div>
                ) : null}

                {getCurrentData(type)?.voucher_invoice_date ? (
                  <div className="mt-1">
                    <div className="mb-1  sub_heading">
                      Voucher Invoice Date
                    </div>
                    <div className="primary_text">
                      {getCurrentData(type)?.voucher_invoice_date}
                    </div>
                  </div>
                ) : null}

                {getCurrentData(type)?.net_amount ? (
                  <div className="mt-2">
                    <div className="mb-1  sub_heading">Net Amount</div>
                    <div className="primary_text">
                      {getCurrentData(type)?.net_amount}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="mt-1 primary_text">
              {getCurrentData(type) ? getCurrentData(type) : "NA"}
            </div>
          )}
        </div>
      </div>
    );
  };
  return (
    <div style={{ marginTop: "2rem" }} className="d-flex">
      <div>
        <img src={CircularEditIcon} alt="" />
        {index <= history?.length - 1 ? (
          <div
            style={{
              width: "2px",
              background: "rgba(191, 203, 225, 0.6)",
              margin: "auto",
              height: "100%",
            }}
          ></div>
        ) : (
          ""
        )}
      </div>

      {/* Right side for content  */}
      <div style={{ width: "95%" }}>
        {
          <div>
            <div className="text">
              <span className="bold_text">{data?.updated_by_user} </span>{" "}
              <span className="action">{data?.operation === "Create" ? "created" : "updated"}{" "}</span>
              <span className="bold_text">invoice</span> on{" "}
              {formateDateTime(data?.updated_at)}
            </div>

            {/* Primary Data  */}
            <PrimaryDetails data={data} getDataObject={getDataObject} />

            {/* Item Data  */}
            <ItemDetails data={data} getDataObject={getDataObject} />

            {/* Payment Data  */}
            <PaymentDetails data={data} getDataObject={getDataObject} />
          </div>
        }
      </div>
    </div>
  );
};

export default SingleUpdatedByDetails;
